// extracted by mini-css-extract-plugin
module.exports = {"root":"Item_root__2Ntto","favoriteButton":"Item_favoriteButton__1RTod","header":"Item_header__wWRaL","headerButtons":"Item_headerButtons__3g40n"};